import { Cache } from "memory-cache";
import { CharacterOrderEntity } from "./CharacterOrdersEntity";

// Cache
const cache = new Cache();
export async function getCachedCharacterOrderEntity(order_id: number): Promise<CharacterOrderEntity | null> {
  let entity: any = await cache.get(order_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCharacterOrderEntity(order: CharacterOrderEntity) {
  cache.put(order.props.order_id.toString(), order, 60 * 60 * 1000 /* 1 hour */);
}
